exports.isProductionEnv = process.env.NODE_ENV === 'production';
exports.server = process.env.API_URL;
exports.bugsnagKey = 'a26c1f6bb8a0242148e3b95041e73b8e';
exports.publicUrl = 'https://connect.kukui.com';
